import styled from "styled-components";
import { BackToTopPageButton } from "../../molecules/BackToTopPageButton";
import { GoogleMap } from "../../organisms/GoogleMap";

export const ShopLocationSearch: React.FC = () => {
  return (
    <ShopLocationSearchContainer>
      <ShopLocationSearchTitle>現在地から選択</ShopLocationSearchTitle>

      <GoogleMap />

      <ButtonWrapper>
        <BackToTopPageButton />
      </ButtonWrapper>
    </ShopLocationSearchContainer>
  );
};

const ShopLocationSearchContainer = styled.div`
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  text-align: left;
  color: #2c3e50;
`;

const ShopLocationSearchTitle = styled.div`
  font-size: 20px;
  font-weight: 500;
  display: flex;
  justify-content: center;
  margin: 107px 0 38px;
  font-family: "Hiragino Sans";
`;

const ButtonWrapper = styled.div`
  display: flex;
  justify-content: center;
  margin-bottom: 57px;
  button {
    font-family: "Hiragino Sans";
    height: auto;
    line-height: 1;
    font-weight: 500;
  }
`;
